<script>
import Button from "@/components/atoms/button";
import Titre from "@/components/atoms/titre";
import FormGroup from "@/components/molecules/form-group";
import FormRadio from "@/components/molecules/form-radio";
import Divider from "@/components/atoms/divider";
import Badge from "@/components/atoms/badge";
import Icon from "@/components/atoms/icon";

export default {
  name: "MesAchatPopin",
  components: {
    Button,
    Titre,
    FormRadio,
    FormGroup,
    Divider,
    Badge,
    Icon
  },
  props: {
    preferenceTicket: {
      type: String,
      required: false,
      default: ""
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    errorUpdatePreference: {
      type: Boolean,
      required: false,
      default: false
    },
    displayEmailChoice: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ["close", "updatePreference"],
  data() {
    return {
      preferenceTicketSelected: this.preferenceTicket
        ? this.preferenceTicket
        : "print"
    };
  }
};
</script>

<template>
  <div class="u-px-sm@md">
    <div
      v-if="error"
      class="u-text-center u-px-md u-px-none@md"
    >
      <Icon
        name="alert-circle-outline"
        variant="alert"
        size="lg"
      />
      <p class="u-font-14 u-mt-md">
        Désolé, une erreur s’est produite. Nous n’avons pas réussi à afficher vos préférences. Veuillez réessayer plus tard
      </p>
    </div>

    <div
      v-else
      class="u-mb-lg20 u-mb-sm@md"
    >
      <div class="u-text-center">
        <Badge
          variant="season"
          circle
          size="xlg"
        >
          <Icon
            name="leaf-tree"
            variant="white"
          />
        </Badge>
        <p class="u-font-secondary u-color-season u-font-700 u-mt-sm u-mb-sm">
          Chaque geste compte !<br>
          Limitons ensemble les déchets papiers.
        </p>
      </div>
      <Divider
        dotted
        class="u-m-none"
      />

      <div>
        <Titre
          tag="h1"
          size="sm"
          class="u-mt-md u-mb-lg u-text-center u-text-left@md"
        >
          Comment souhaitez-vous obtenir vos tickets de caisse lors de vos achats en magasin ?
        </Titre>

        <FormGroup class="u-mb-md">
          <FormRadio
            v-if="displayEmailChoice"
            v-model="preferenceTicketSelected"
            name="radio"
            class="u-mb-sm"
            value="email"
          >
            Envoi par email
          </Formradio>
          <FormRadio
            v-model="preferenceTicketSelected"
            name="radio"
            class="u-mb-sm"
            value="print"
          >
            Impression papier en magasin
          </Formradio>
          <FormRadio
            v-model="preferenceTicketSelected"
            name="radio"
            class="u-mb-sm"
            value="no_print"
          >
            Aucun email ni impression papier
          </Formradio>
        </FormGroup>
        <div class="u-flex u-flex-align-start u-mb-md">
          <Icon
            name="info-circle"
            variant="primary-light"
            size="sm"
            class="u-flex-shrink-none u-mr-xs"
          />
          <p class="u-color-text-light u-font-14">
            À noter : Quel que soit votre choix, vos tickets seront disponibles dans votre espace "Mes achats".
          </p>
        </div>
        <div class="u-text-center">
          <Button
            variant="primary"
            outline
            radius="full"
            size="md"
            @click="$emit('close')"
          >
            Annuler
          </Button>
          <Button
            variant="primary"
            radius="full"
            size="md"
            class="u-ml-sm"
            @click="$emit('updatePreference', preferenceTicketSelected)"
          >
            Enregistrer
          </Button>
        </div>
        <div
          v-if="errorUpdatePreference"
          class="u-flex u-flex-align-start u-mt-md u-mt-sm@md"
        >
          <Icon
            name="alert-circle-outline"
            variant="alert"
            size="sm"
            class="u-flex-shrink-none u-mr-xs"
          />
          <p class="u-color-error u-font-14">
            Désolé, une erreur s’est produite. Nous n’avons pas réussi à enregistrer vos préférences. Veuillez réessayer plus tard
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
